import { BasketCookie, getBasketCookie } from 'utils/basket';
import { isUserAuth } from 'utils/cookie';
import { loadBasketRemote } from '../helpers';
import { getCountryHref, dispatchEvent } from 'utils/common';
import { BASKET_EVENT_UPDATE, BASKET_EVENT_UPDATE_SERVICE } from '../consts';
import { getServicesCookie } from '../../../../../utils/services';

const BASKET_PATH = '/basket';

let loadBasketPromise: Promise<BasketCookie[]> | undefined;


export const cleanCache = () => {
  loadBasketPromise = undefined;
}

const loadBasketWithCache = (): Promise<BasketCookie[]> => {
  if (!loadBasketPromise) {
    loadBasketPromise = loadBasketRemote();
  }

  return loadBasketPromise;
}

export const handleBasketLoad = async () => {
  const isAuthorized = isUserAuth();
  const path = location.pathname;

  const basket = isAuthorized && path.startsWith(getCountryHref(path, BASKET_PATH)) ? await loadBasketWithCache() : getBasketCookie() ?? [];
  const services = getServicesCookie() || [];

  dispatchEvent(BASKET_EVENT_UPDATE, basket);
  dispatchEvent(BASKET_EVENT_UPDATE_SERVICE, services);
};
